var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 20.3572L12 15.2143L6.85718 20.3572V4.9286C6.85718 4.5876 6.99264 4.26058 7.23375 4.01946C7.47487 3.77834 7.80189 3.64288 8.14289 3.64288H15.8572C16.1981 3.64288 16.5252 3.77834 16.7663 4.01946C17.0074 4.26058 17.1429 4.5876 17.1429 4.9286V20.3572Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionNew);
export default __webpack_public_path__ + "static/media/SubscriptionNew.a0be7b1848185e1ab8141fb79bb5c3e4.svg";
export { ForwardRef as ReactComponent };